module.exports = __webpack_public_path__ + "img/58.867665aa.jpg";